import React, { useEffect, useState, useContext } from 'react';
import { Helmet } from 'react-helmet';
import usePageBackground from '../hooks/usePageBackground';
import { Link, useSearchParams } from 'react-router-dom';
import { Grid, Card, CardActionArea, CardMedia, CardContent, CardActions, Typography, Container, Pagination, Stack } from '@mui/material';
import * as endPoints from '../assets/js/endpoints';
import * as utils from '../assets/js/utils';
import { UserContext } from '../assets/contexts/userContext';
import FadeItem from "../components/fadeItem";
import { useFadeInOnScroll } from "../theme/global";
import Loader from '../components/loader';

const Blog = () => {
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialPage = parseInt(searchParams.get('page') || '1', 10);
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const { user } = useContext(UserContext);
  const containerRef = useFadeInOnScroll([loading]);


  usePageBackground('blog-background-color');

  useEffect(() => {
    const sp = parseInt(searchParams.get('page') || '1', 10);
    if (sp !== page) {
      setPage(sp);
    }
  }, [searchParams]);

  const handlePageChange = (event, value) => {
    setSearchParams({ page: value });
    setPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    setLoading(true);
    endPoints.getAllArticles(page, 9)
      .then(data => {
        const list = Array.isArray(data) ? data : data.data;
        setArticles(list);
        setTotalPages(data.last_page || 1);
      })
      .finally(() => setLoading(false));
  }, [page]);


  if (loading) {
    return <Loader />;
  }

  return (
    <>
    <Helmet>
      <title>Blog | CES</title>
      <meta name="description" content="Lee nuestras últimas publicaciones y novedades." />
    </Helmet>
    <Container ref={containerRef} className="fade-up" sx={{ p: 4 }}>
      <Grid container spacing={3} sx={{ mt: 2 }}>
      <Container sx={{ my: 2, textAlign: "center" }} >
      <FadeItem
        text="Blog"
        variant="h2"
        style={{ fontFamily: "Great Vibes, cursive", fontWeight: 400, color: "#66ab5ea3", mb: 2 }}
      />
      </Container>
        {  articles.length === 0 ? (
          <Grid xs={12} sm={12} md={12} sx={{gridColumn: '1 / -1',       // abarca desde la columna 1 hasta la última
            display: 'flex',            // usa flexbox para centrar
             justifyContent: 'center',   // centra horizontalmente
             mt:3}} > 
          <FadeItem
          text="¡Pronto publicaremos artículos muy interesantes sobre salud!"
          variant="h3"
          style={{ fontFamily: "Great Vibes", fontWeight: 400, color: "#66ab5ea3", mb: 2 }}
        />  
          </Grid>
            ) : (
        articles.map((article) => (
          <Grid item key={article.id} xs={12} sm={6} md={4}>
            <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', backgroundColor: "#f5f5f5" }}>
              <CardActionArea component={Link} to={`/blog/${article.id}`}>
                {article.image && (
                  <CardMedia
                    component="img"
                    height="160"
                    image={utils.image_path(article.image)}
                    alt={article.title}
                  />
                )}
                <CardContent>
                  <Typography gutterBottom variant="h6" component="div">
                    {article.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {utils.trimText(article.text, 2)}
                  </Typography>
                  {article.service && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                       {article.service.name || article.service.title}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>
              {user.canEditArticle(article.user_id) && (
                <CardActions>
                  <Link to={`/blog/editar/${article.id}`}>Editar</Link>
                </CardActions>
              )}
            </Card>
          </Grid>
        )))}
      </Grid>
      {  !articles.length === 0 ? 
      <Stack alignItems="center" justifyContent="center" sx={{ mt: 4 }}>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
      </Stack>
      : null }
    </Container>
    </>
  );
};

export default Blog;
